module.exports = __webpack_public_path__ + "static/media/ic_transaction_history.108d99de.svg";